module.exports = __webpack_public_path__ + "static/3-5b5a5a3110b02600b812851577300915.jpg";